@if (!ordered) {
  <app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
}
<div class="container">
  <div class="mx-0 row">
    @if (!loaded && !basket) {
      <app-basket-skeleton-loader />
    }
    @if (basket && !ordered) {
      <div class="ps-0 pe-2 col-md-12">
        <div class="info p-3 row">
          <div class="col-12 col-lg-6">
            <h1 class="mt-0 d-flex">
              <app-header-icon iconName="local_shipping"></app-header-icon>
              {{ "CHECKOUT" | translate }} &centerdot; {{ basket.items?.length }}
              {{
              (basket.items?.length === 1 ? "ARTICLE" : "ARTICLES") | translate
              }}
              @if (basket.pre_order) {
                <span class="px-2 mx-1 badge bg-warning badge-pill">{{ "PREORDER" | translate
                }}</span>
              }
            </h1>
            @if (!basket.pre_order) {
              <h2 class="pb-2 subHeader">
                {{ basket.name }}
              </h2>
            }
          </div>
          <div class="col-12 col-lg-6 pt-2">
            @if (basket.shipping_address) {
              <div class="d-flex flex-column pb-3">
                <h5>{{ "SHIPPINGADDRESS" | translate }}:</h5>
                <strong class="d-block">{{ basket.shipping_address.name }}</strong>
                <span>{{ basket.shipping_address.address }}</span>
                {{ basket.shipping_address.zip }} {{ basket.shipping_address.city }}
              </div>
            }
            @if (basket.pre_order) {
              <p [innerHTML]="'PREORDER_INTRO_' + companyGroupCode | translate"></p>
            }
          </div>
          <div class="col-12">
            <app-cms-page-content [pageId]="checkoutMessageId" [showNotFound]="false"></app-cms-page-content>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-9 ps-2">
            <!-- Locked basket overlay -->
            @if (basket.locked) {
              <div
                class="top-0 p-3 basket-locked position-absolute w-100 h-100 d-flex justify-content-center align-items-center m-n3"
                >
                <span class="me-2 material-icons text-danger"> lock </span>
                <span class="me-3">{{ "BASKET_LOCKED" | translate }}</span><button class="btn btn-sm btn-outline-primary"
                (click)="unlockBasket()">
                {{ "UNLOCK_BASKET" | translate }}
              </button>
            </div>
          }
          @if (basket.unchecked_article_type === 'Parts' || basket.unchecked_article_type === 'Multiple') {
            <app-unchecked-articles-notice
            [type]="'PARTS'"></app-unchecked-articles-notice>
          }
          <!-- Parts -->
          @if (
            groupedArticles &&
            groupedArticles['parts'] &&
            groupedArticles['parts'].items.length
            ) {
            <app-grouped-articles class="d-block" (contentChanged)="calcTotal(basket.items)" [groupedArticles]="groupedArticles['parts']"
              [allArticles]="basket.items" [currency]="basket.total_price?.currency" [header]="'PARTS_ACCESSORIES'"
              [sum]="basketSum['parts']" [sum_available]="basketSum['parts_available']" [compact]="false" [type]="'parts'"
            [basketId]="basket.id" [checkout]="true" [coupons]="coupons.parts"></app-grouped-articles>
          }
          @if (basket.unchecked_article_type === 'Bikes' || basket.unchecked_article_type === 'Multiple') {
            <app-unchecked-articles-notice
            [type]="'BICYCLES'"></app-unchecked-articles-notice>
          }
          <!-- Bicycles -->
          @if (
            groupedArticles &&
            groupedArticles['bicycles'] &&
            groupedArticles['bicycles'].items.length
            ) {
            <app-grouped-articles class="d-block" [type]="'bicycles'" (contentChanged)="calcTotal(basket.items)"
              [groupedArticles]="groupedArticles['bicycles']" [currency]="basket.total_price?.currency"
              [allArticles]="basket.items" [sum_available]="basketSum['bicycles_available']" [header]="'BICYCLES'"
              [sum]="basketSum['bicycles']" [compact]="false" [basketId]="basket.id" [checkout]="true"
            [coupons]="coupons.bicycles"></app-grouped-articles>
          }
          <!-- Preorder -->
          @if (basket.pre_order) {
            <div class="d-flex row">
              @if (
                groupedArticlesByDirectDelivery &&
                groupedArticlesByDirectDelivery.items.length &&
                basketSumDirect
                ) {
                <app-grouped-articles class="col-md-12 d-block w-100 ps-0" [style.order]="0" [allArticles]="basket.items"
                  [groupedArticles]="groupedArticlesByDirectDelivery" [header]="'DELIVER_WHEN_POSSIBLE'"
                  [sum]="basketSumDirect['direct']" [compact]="false" [basketId]="basket.id" [checkout]="true"
                  [preorder]="true" [currency]="basket.total_price?.currency"
                  [showShopDropdown]="basket.article_shop_dropdown"
                  [lockedDeliveryWeeks]="basket.locked_delivery_week_all">
                </app-grouped-articles>
              }
              @for (m of totalMonths; track m) {
                @if (
                  groupedArticlesByMonth &&
                  groupedArticlesByMonth[m] &&
                  groupedArticlesByMonth[m].items.length
                  ) {
<app-grouped-articles class="col-md-12 d-block w-100 ps-0" [style.order]="
                    groupedArticlesByMonth[m].items[0].delivery_year -
                    2000 +
                    '' +
                    applicationService.getTimeslotFromMonth(
                      m.toString() | slice : 4 : 6
                    )
                  " (contentChanged)="calcTotal(basket.items)" [groupedArticles]="groupedArticlesByMonth[m]" [header]="
                    individualPreorderCheckout
                      ? 'TIMESLOT_' +
                        applicationService.getTimeslotFromMonth(
                          m.toString() | slice : 4 : 6
                        )
                      : 'MONTH_' + (m.toString() | slice : 4 : 6)
                  " [sum]="basketSumMonths[m]" [compact]="false" [basketId]="basket.id" [checkout]="true"
                    [preorder]="true" [currency]="basket.total_price?.currency"
                    [showShopDropdown]="basket.article_shop_dropdown" [allArticles]="basket.items"
                    [lockedDeliveryWeeks]="basket.locked_delivery_week_all">
                    {{ groupedArticlesByMonth[m].items[0].delivery_year }}
                  </app-grouped-articles>
                }
              }
              @if (
                groupedArticlesByMonth &&
                groupedArticlesByMonth['demo'] &&
                groupedArticlesByMonth['demo'].items.length
                ) {
                <app-grouped-articles class="col-md-12 d-block w-100 ps-0" [style.order]="2998" (contentChanged)="calcTotal(basket.items)" [allArticles]="basket.items"
                  [showCheckoutOption]="!individualPreorderCheckout" [groupedArticles]="groupedArticlesByMonth['demo']"
                  [header]="'DEMO'" [sum]="basketSumMonths['demo']" [checkout]="true" [basketId]="basket.id"
                  [preorder]="true" [groupId]="'DEMO'" [currency]="basket.total_price?.currency"
                  [showShopDropdown]="basket.article_shop_dropdown"
                  [lockedDeliveryWeeks]="basket.locked_delivery_week_all">
                  {{ groupedArticlesByMonth["demo"].items[0].delivery_year }}
                </app-grouped-articles>
              }
              @if (
                groupedArticlesByMonth &&
                groupedArticlesByMonth['repair'] &&
                groupedArticlesByMonth['repair'].items.length
                ) {
                <app-grouped-articles class="col-md-12 d-block w-100 ps-0" [style.order]="2999" (contentChanged)="calcTotal(basket.items)" [allArticles]="basket.items"
                  [showCheckoutOption]="!individualPreorderCheckout" [groupedArticles]="groupedArticlesByMonth['repair']"
                  [header]="'REPAIR'" [sum]="basketSumMonths['repair']" [checkout]="true" [basketId]="basket.id"
                  [preorder]="true" [groupId]="'REPAIR'" [currency]="basket.total_price?.currency"
                  [showShopDropdown]="basket.article_shop_dropdown"
                  [lockedDeliveryWeeks]="basket.locked_delivery_week_all">
                  {{ groupedArticlesByMonth["repair"].items[0].delivery_year }}
                </app-grouped-articles>
              }
            </div>
          }
        </div>
        <div class="col-12 col-sm-3">
          <sticky id="sticky" #sticky [sticky-media-query]="'min-width: 576px'"
            [sticky-offset-top]="fixedNavBar ? 100 : 0" [style.min-width]="stickyWidth ? stickyWidth + 'px' : 0">
            <h4 class="mb-3">&nbsp;</h4>
            @if (basket && basket.id && !showroomMode) {
              <app-free-shipping-progress class="mb-2" [basketId]="basket.id"
                [showDetails]="true" [total]="basketSum['parts']" [type]="'Parts'">
              </app-free-shipping-progress>
            }
            @if (basketSum.totalWithShipping > 0) {
              <div class="px-2 p-sm-3 list-group list-group-flush col-md-12 sum totalSum"
                >
                <div class="col-12 px-sm-2">
                  <div class="mb-1 row px-2 px-sm-0 shipping-details">
                    @if (
                      !basket.shipping_costs_mandatory &&
                      basket.shipping_cost &&
                      !basket.pre_order &&
                      applicationService.getSelectCompanyGroupCode() !== 'WG'
                      ) {
                      <div class="px-2 text-end col-md-12 shippingSum">
                        {{ "SHIPPINGCOST" | translate }}:
                        @if (basket.shipping_cost && !basket.pre_order) {
<span [innerHTML]="
                        basket.shipping_cost.value
                          | currencyConvert : basket.shipping_cost?.currency
                      "></span>
                        }
                      </div>
                    }
                  </div>
                  @if (total_coupon_discount['parts']) {
                    <div class="mb-2 row px-2">
                      <div class="px-0 text-end col-md-12 shippingSum">
                        {{ "TOTAL_COUPONS" | translate }} ({{"PARTS" | translate}})
                    <span class="d-sm-block d-md-inline-block" [innerHTML]="
                        -total_coupon_discount['parts']
                          | currencyConvert : basket.total_price?.currency
                      "></span>
                      </div>
                    </div>
                  }
                  @if (total_coupon_discount['bicycles']) {
                    <div class="mb-2 row px-2">
                      <div class="px-0 text-end col-md-12 shippingSum">
                        {{ "TOTAL_COUPONS" | translate }} ({{"BICYCLES" | translate}})
                    <span class="d-sm-block d-md-inline-block" [innerHTML]="
                        -total_coupon_discount['bicycles']
                          | currencyConvert : basket.total_price?.currency
                      "></span>
                      </div>
                    </div>
                  }
                  @if (total_coupon_discount['none']) {
                    <div class="mb-2 row px-2">
                      <div class="px-0 text-end col-md-12 shippingSum">
                        {{ "TOTAL_COUPONS" | translate }}
                    <span class="d-sm-block d-md-inline-block" [innerHTML]="
                        -total_coupon_discount['none']
                          | currencyConvert : basket.total_price?.currency
                      "></span>
                      </div>
                    </div>
                  }
                  <div class="row">
                    @if (companyGroupCode === 'RAL' && !showroomMode) {
                      <app-credit-limit class="px-0"
                        [currency]="basket.total_price?.currency" />
                    }
                  </div>
                  <div class="row px-2">
                    <div class="px-0 col-12 totalSum shipping-details">
                      <div class="col-md-12 totalSum d-flex flex-column justify-content-end align-items-end">
                        @if (basket?.selected_shipping_costs?.Parts && !showroomMode) {
                          <app-shipping-cost-overview class="w-100"
                            [shippingCosts]="basket?.selected_shipping_costs?.Parts" [selectedShippingOverview]="true"
                            [showDetails]="false" [type]="'PARTS_ACCESSORIES'"
                          [total]="basketSum?.parts"></app-shipping-cost-overview>
                        }
                        @if (basket?.selected_shipping_costs?.Bicycles && !showroomMode) {
                          <app-shipping-cost-overview class="w-100"
                            [shippingCosts]="basket?.selected_shipping_costs?.Bicycles" [selectedShippingOverview]="true"
                          [type]="'BICYCLES'" [total]="basketSum?.bicycles"></app-shipping-cost-overview>
                        }
                        @if (((!basket?.selected_shipping_costs?.Parts && basketSum?.parts !== '0.00' && !showroomMode && showTotalsOfParts) || showroomMode) && !freeShippingProgress?.shippingCost) {
                          <div class="d-block w-100"
                            >
                            {{ "PARTS_ACCESSORIES" | translate }}:
                            <span [innerHTML]="basketSum?.parts | currencyConvert : basket.total_price?.currency"></span>
                          </div>
                        }
                        @if (((!basket?.selected_shipping_costs?.Bicycles && basketSum?.bicycles !== '0.00' && !showroomMode && showTotalsOfBicycles) || showroomMode) && !freeShippingProgress?.shippingCost) {
                          <div class="d-block w-100"
                            >
                            {{ "BICYCLES" | translate }}:
                            <span [innerHTML]="basketSum?.bicycles | currencyConvert : basket.total_price?.currency"></span>
                          </div>
                        }
                        <div
                          class="d-flex flex-wrap justify-content-between gap-2 w-100 border-top border-dark-subtle total-text pt-2 mt-2 align-items-center">
                          <div class="ms-auto">
                            {{ "TOTAL" | translate }}:
                            <span class="d-md-inline-block"
                            [innerHTML]="basketSum.totalWithShipping | currencyConvert : basket.total_price?.currency"></span>
                          </div>
                        </div>
                        @if (quote) {
                          <div class="border p-2 mt-2">
                            @if (!showroomMode) {
                              <app-basket-payment-costs-overview [basketQuote]="quote"
                              [basketArticlesSum]="basket.total_price?.value"></app-basket-payment-costs-overview>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </sticky>
        </div>
        @if (basket.shipping_costs_mandatory && ((!this.basket.pre_order && (groupedArticles?.parts?.items?.length || groupedArticles?.bicycles?.items?.length)) || basket.pre_order)) {
          <div
            class="shippingSelectContainer d-none"
            [hidden]="basket.pre_order">
            <h3>
              <span class="material-icons" style="transform: translateY(1.5px)">date_range</span>
              {{ "SHIPMENT_DATE" | translate }}
            </h3>
            @if (
              basket.selected_shipping_costs?.Parts ||
              basket.selected_shipping_costs?.Bicycles) {
              @if (
                (groupedArticles &&
                groupedArticles['parts'] &&
                groupedArticles['parts'].items.length) || preorderType === 'Parts'
                ) {
                <app-select-checkout-shipping-date [shippingDateOptions]="basket.selected_shipping_costs.Parts" [label]="'PARTS_ACCESSORIES' | translate"
                (dateSelected)="shippingDateParts = $event"></app-select-checkout-shipping-date>
              }
              @if (
                (groupedArticles &&
                groupedArticles['bicycles'] &&
                groupedArticles['bicycles'].items.length) || preorderType === 'Bicycles'
                ) {
                <app-select-checkout-shipping-date [shippingDateOptions]="basket.selected_shipping_costs.Bicycles" [label]="'BICYCLES' | translate"
                (dateSelected)="shippingDateBicycles = $event"></app-select-checkout-shipping-date>
              }
            } @else {
              <ngb-alert type="danger" [dismissible]="false">{{
                "NO_SHIPPING_OPTIONS_FOUND" | translate
              }}</ngb-alert>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (ordered) {
    <div class="px-3 col-md-12">
      <app-sent-basket-overview [basketId]="basketId" [basket]="orderedBasket"
      [unOrderedArticles]="unOrderedArticles"></app-sent-basket-overview>
    </div>
  }
</div>


<ng-template #options>
  @if (basket && !ordered) {
    <div class="px-0 col-md-12 d-flex justify-content-between align-items-center">
      <button class="me-auto btn btn-lg btn-dark" (click)="back()">
        {{ "BACK" | translate }}
      </button>
      @if (
        basket.pre_order &&
        (companyGroupCode === 'WG' || companyGroupCode === 'GHO')) {
        <button class="btn btn-lg btn-success" (click)="paycond()" [disabled]="
            !basket.ordering_allowed || basket.locked ? 'disabled' : ''
          " [ngClass]="
            !basket.ordering_allowed || basket.locked ? 'disabled' : ''
          ">
          {{ "NEXT" | translate }}
        </button>
      } @else {
        @if ((this.basket.terms_and_conditions || this.basket.privacy_policy)) {
          <app-accept-conditions-and-privacy
            class="ms-1" [privacy_policy]="basket.privacy_policy" [terms_and_conditions]="basket.terms_and_conditions"
            (checkboxChanged)="notAgreed = !$event" />
        }
        @if (showPaymentButton && paymentAllowed) {
<button class="me-3 btn btn-lg btn-success" [disabled]="
            (!basket.ordering_allowed ||
            clicked ||
            notAgreed ||
            basket.locked ||
            !validShippingDates
              ? 'disabled'
              : '') || !loaded
          " [ngClass]="[
            !basket.ordering_allowed || basket.locked || !validShippingDates || !loaded
              ? 'disabled'
              : '',
              !loaded ? 'loading' : '']
          " (click)="goToPaymentUrl()">
            {{ "PAY_AND_SEND" | translate }}
          </button>
        }
        @if (showPaymentButton && !paymentAllowed) {
          <ngb-alert type="danger" [dismissible]="false" class="me-2 mb-0">
            {{"PAYMENT_NOT_ALLOWED_BICYCLED_PARTS_COMBINED" | translate}}
          </ngb-alert>
        }
        @if (
          !ordered &&
          (onlinePaymentRestrictionLevel === 0 ||
          onlinePaymentRestrictionLevel === 2 ||
          onlinePaymentRestrictionLevel === 3)
          ) {
<button class="btn btn-lg btn-success" style="min-width: 15%; max-width: 40vw" (click)="checkout()" [disabled]="
            !basket.ordering_allowed ||
            clicked ||
            notAgreed ||
            basket.locked ||
            !validShippingDates
              ? 'disabled'
              : ''
          " [ngClass]="[
            !basket.ordering_allowed || basket.locked || !validShippingDates
              ? 'disabled'
              : '',
            !loaded ? 'loading' : ''
          ]" [ngbTooltip]="
            (!basket.ordering_allowed
              ? 'ACCOUNT_ORDERING_NOT_ALLOWED'
              : 'BASKET_LOCKED'
            ) | translate
          " [disableTooltip]="basket.ordering_allowed" [closeDelay]="999999" [autoClose]="false"
            [tooltipClass]="'not_allowed_tooltip'" #tooltip_checkout="ngbTooltip">
            <span>
              {{ "SEND" | translate }}
            </span>
          </button>
        }
      }
    </div>
  }
</ng-template>
</div>
@if (showNavbar) {
  <app-bottom-navbar [fixed]="true">
    <ng-container *ngTemplateOutlet="options"></ng-container>
  </app-bottom-navbar>
}